import ReactDOM from 'react-dom';

export const ConditionalPortal = (props) => {
  if (props.condition) {
    return ReactDOM.createPortal(props.children, props.destination);
  } else {
    return props.children;
  }
};
